// Shared public-site links. Keep these here — they are referenced from the
// header, landing page, docs, and tests, and must not drift apart.
export const CALENDAR_URL = "https://calendar.app.google/nY5bouhSGbhRpTji6";
export const GITHUB_URL = "https://github.com/mathaix/OpenClawMachines";
